import { createContext } from 'react';
import { useAutomationEditor } from './useAutomationEditor';

type ContextValue = {
  editor: ReturnType<typeof useAutomationEditor>;
};

export const AutomationEditorContext = createContext<ContextValue | null>(null);
